<template>
  <div id="app">
    <v-header/>
    <router-view style="margin-top:70px;"/>
    <v-footer/>
  </div>
</template>

<script>
import VHeader from './components/header'
import VFooter from './components/footer'
export default {
  name: 'App',
  components: {
      VHeader,
      VFooter
  },
}
</script>

<style lang="less"> 
@import './assets/css/index.less';
#app {
  
  .swiper-button-prev{
    left: -40px !important;
    top: 37% !important;
    background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%230168b7'%2F%3E%3C%2Fsvg%3E") !important;

  }

  .swiper-button-next{
    right: -10px !important;
    top: 37% !important;
    background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%230168b7'%2F%3E%3C%2Fsvg%3E") !important;
  }


  display: inline-block;
  width:100%;
  height: 100%;
  margin: 0;
  font-size: 0rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue